"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderQRCodeSection = renderQRCodeSection;
var _litHtml = require("lit-html");
var _QRCodeCard = require("./QRCodeCard");
require("./QRCodeSection.css");
function renderQRCodeSection(subject, store) {
  return (0, _litHtml.html)`
      <section class="profile__section profile__qr-code" data-profile-section="qr-code" aria-labelledby="qr-heading" tabindex="-1">
        <h3 id="qr-heading" class="sr-only">QR code</h3>
        ${(0, _QRCodeCard.QRCodeCard)(subject, store)}
      </section>
  `;
}